import React from 'react';

import { ReactFCV } from '@types';

import { LOWER_MESSAGE_LENGTH, TOP_MESSAGE_LENGTH } from './constants';
import { CircleSkeleton, MessageSkeleton, SkeletonWrapper, TitleSkeleton } from './styled';

export const PaymentRedirectPageSkeleton: ReactFCV = () => (
  <SkeletonWrapper>
    <CircleSkeleton />
    <TitleSkeleton />
    <MessageSkeleton width={TOP_MESSAGE_LENGTH} />
    <MessageSkeleton width={LOWER_MESSAGE_LENGTH} />
  </SkeletonWrapper>
);
